import { ProductImportMode } from '@/components/import-flow/view-products-option-selection';
import { DatasourceInstructionMode } from '@/lib/graphql/generated/graphql';
import { TFunction } from 'i18next';

/**
 * Maps ProductImportMode to DatasourceInstructionMode
 */
export const mapProductImportModeToInstructionMode = (
  mode: ProductImportMode
): DatasourceInstructionMode => {
  switch (mode) {
    case 'add':
      return DatasourceInstructionMode.CreateOnly;
    case 'update':
      return DatasourceInstructionMode.UpdateOnly;
    default:
      return DatasourceInstructionMode.CreateOnly;
  }
};

/**
 * Maps DatasourceInstructionMode to user-friendly labels
 */
export const getInstructionModeLabel = (
  mode: DatasourceInstructionMode,
  t: TFunction
): string => {
  switch (mode) {
    case DatasourceInstructionMode.CreateOnly:
      return t('components.import_flow.instruction_mode.add_new_products');
    case DatasourceInstructionMode.UpdateOnly:
      return t(
        'components.import_flow.instruction_mode.update_existing_products'
      );
    case DatasourceInstructionMode.CreateAndUpdate:
      return t('components.import_flow.instruction_mode.add_and_update');
    case DatasourceInstructionMode.SyncWithDealItemId:
      return t(
        'components.import_flow.instruction_mode.sync_with_deal_item_id'
      );
    default:
      return t('components.import_flow.instruction_mode.add_and_update');
  }
};
